var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.817,
    cy: 17.42,
    r: 1.444
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M16.417 26.627l5.277-5.278 5.278 5.278M21.694 23.684v12.011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M10.476 15.592h-.078c-2.735 0-4.946 2.219-4.946 4.946s2.211 4.939 4.946 4.939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.165 13.647v-.008a3.975 3.975 0 00-3.798-2.79 3.966 3.966 0 00-3.97 3.97c0 .266.023.524.07.774h.008M31.215 15.678a4.947 4.947 0 015.852 4.86 4.94 4.94 0 01-4.946 4.939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.165 13.647v-.117c0-3.704 3.001-6.705 6.705-6.705s6.705 3.001 6.705 6.705c0 .75-.125 1.477-.359 2.149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.fa865652c17ffb42fcca8236e44b59fd.svg";
export { ForwardRef as ReactComponent };